<div class="alerts-danger-container alert alert-danger" *ngIf="displayAlert">
  <i class="fa-icon fa fa-ban"></i>
  <div class="content">
    <span class="subject" id="{{subjectDangerId}}"></span>
    <p class="content" id="{{contentDangerId}}"></p>
  </div>
</div>
